import { useCallback } from "react";

import { useSelector } from "react-redux";

import { useTwilioDevice } from "Hooks/useTwilioDevice/useTwilioDevice";
import { emitMuteEvent } from "Services/ConversationsApiService";
import {
    selectSnapshotConferenceFriendlyID,
    selectConferenceSnapshotSelf,
} from "Services/state/conferences/ConferenceSnapshotSelectors";

import { logger } from "../../CallBar.utils";

export type UseMuteCallResult = {
    isMuted: boolean;
    toggleMute: () => void;
};

export const useCallActionMute = (): UseMuteCallResult => {
    // there isn't a way to get rid of this right now
    const { activeCall } = useTwilioDevice();

    const snapshotConferenceFriendlyId = useSelector(selectSnapshotConferenceFriendlyID);
    const agent = useSelector(selectConferenceSnapshotSelf);

    const { callSid: agentCallSid, muted: agentMuted } = agent || {};

    const toggleSnapshotMute = useCallback(() => {
        if (!activeCall) {
            logger.warn("Tried to mute call but no active call found");
            return;
        }

        const toggledMuted = !agentMuted;
        activeCall.mute(toggledMuted);
        emitMuteEvent({
            conferenceFriendlyId: snapshotConferenceFriendlyId,
            mute: toggledMuted,
            callSid: agentCallSid,
        });
    }, [activeCall, agentMuted, snapshotConferenceFriendlyId, agentCallSid]);

    return { isMuted: !!agentMuted, toggleMute: toggleSnapshotMute };
};
